import PropTypes from 'prop-types';
import React from 'react';

import Grid from '../../components/Grid';
import Clickable from '../../components/Clickable';
import Image from '../../components/Image/Image';

export default function AnswerImage(_ref) {
  var textElements = _ref.textElements,
      multipleChoice = _ref.multipleChoice;

  return React.createElement(
    Grid,
    { theme: multipleChoice && 'singleRow' },
    textElements.map(function (textElement) {
      return React.createElement(
        Clickable,
        { key: textElement.id, element: textElement, multipleChoice: multipleChoice },
        React.createElement(Image, Object.assign({}, textElement, { theme: 'taskAnswer', expand: true }))
      );
    })
  );
}

AnswerImage.propTypes = process.env.NODE_ENV !== "production" ? {
  textElements: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string
  })),
  multipleChoice: PropTypes.bool
} : {};

AnswerImage.defaultProps = {
  textElements: [],
  multipleChoice: false
};